<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-data_filled-description') }}
        </p>
    </div>
</template>
<script>
export default {
    data: function () {
        return {};
    },
    created: function () {},
    mounted: function () {
        window.setTimeout(() => {
            this.changed();
        }, 100);
    },
    computed: {},
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changed: function () {
            this.$emit("input", [{}]);
        },
        isValid: function () {
            return true;
        },
    },
};
</script>
